import { create } from "zustand";
import { fetchFavorites, addFavorite, removeFavorite } from "../lib/api";

export const useFavoritesStore = create((set, get) => ({
  ids: [],
  loaded: false,

  load: async () => {
    try {
      const data = await fetchFavorites();
      set({ ids: data.product_ids || [], loaded: true });
    } catch {
      set({ ids: [], loaded: true });
    }
  },

  isFavorite: (productId) => get().ids.includes(productId),

  toggle: async (product) => {
    const pid = product.id;
    const has = get().ids.includes(pid);
    // MAJ optimiste
    set({ ids: has ? get().ids.filter((x) => x !== pid) : [...get().ids, pid] });
    try {
      if (has) await removeFavorite(pid);
      else await addFavorite(pid, product.title);
    } catch (e) {
      // rollback en cas d'échec
      set({ ids: has ? [...get().ids, pid] : get().ids.filter((x) => x !== pid) });
      throw e;
    }
  },

  clearLocal: () => set({ ids: [], loaded: false }),
}));
